import React from 'react';
import { Sparkles } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { Badge } from '@/components/ui/badge';
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from '@/components/ui/tooltip';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '@/contexts/AuthContext';

export const AISearchToggle: React.FC = () => {
  const navigate = useNavigate();
  const { user } = useAuth();

  return (
    <TooltipProvider>
      <Tooltip>
        <TooltipTrigger asChild>
          <Button
            variant="default"
            size="sm"
            onClick={() => navigate('/ai-recommendations')}
            className="gap-2 bg-primary  transition-all"
          >
            <Sparkles className="w-4 h-4" />
            AI Assistant
            {!user && <Badge variant="secondary" className="ml-1">Free</Badge>}
          </Button>
        </TooltipTrigger>
        <TooltipContent>
          <p>Get AI-powered recommendations and chat with Vergo AI</p>
        </TooltipContent>
      </Tooltip>
    </TooltipProvider>
  );
};
